import InputAdornment from "@material-ui/core/InputAdornment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "@material-ui/core/Button";
import React, {useState} from "react";
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import * as yup from 'yup';
import {setLocale} from 'yup';
import {Dialog} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {useMutation} from "@apollo/client";
import {gql} from "@apollo/client/core";
import {FormattedMessage, useIntl} from "react-intl";
import {yupEnglishLocale, yupGermanLocale} from "../yup";
import {useRouter} from "next/router";

const SEND_MESSAGE = gql`
mutation sendContactMessage(
    $name: String!
    $phone: String
    $email: String!
    $message: String!
) {
    sendContactMessage(message: {
        name: $name
        phone: $phone
        email: $email
        message: $message
    })
}
`;

function ContactForm() {
    const [sendMessage] = useMutation(SEND_MESSAGE);
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);
    const intl = useIntl();
    const router = useRouter();
    const locale = router.locale ?? router.defaultLocale;

    if (locale === 'de') {
        setLocale(yupGermanLocale);
    } else {
        setLocale(yupEnglishLocale);
    }

    const contactFormSchema = yup.object().shape({
        name: yup.string().required(),
        phone: yup.string().required(),
        email: yup.string().required().email(),
        message: yup.string().required(),
    });


    return (
        <React.Fragment>
            <Formik
                initialValues={{name: '', phone: '', email: '', message: ''}}
                onSubmit={async (values, {setSubmitting, setErrors, resetForm}) => {
                    try {
                        await sendMessage({variables: values});
                        setSuccessDialogOpen(true);
                        resetForm();

                    } catch (e) {
                        if (e.graphQLErrors && e.graphQLErrors[0].message === 'Validation errors') {
                            console.log(e.graphQLErrors[0].state.message);
                            let errors = {};

                            e.graphQLErrors[0].state.message.forEach(function (value) {
                                errors[value.path] = value.message;
                            });
                            setErrors(errors);
                        }
                    }
                    setSubmitting(false);
                }}
                validationSchema={contactFormSchema}
            >
                {({isSubmitting}) => (
                    <Form noValidate>
                        <Field
                            name="name"
                            label={intl.formatMessage({id: 'contact_labelName'})}
                            type="text"
                            component={TextField}

                            autoComplete={"name"}
                            fullWidth={true}
                            margin="normal"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment color={"primary"} position="start">
                                        <FontAwesomeIcon fixedWidth icon={['far', 'user']}/>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Field
                            name="phone"
                            label={intl.formatMessage({id: 'contact_labelPhone'})}
                            type="tel"
                            component={TextField}

                            autoComplete={"tel"}
                            fullWidth={true}
                            margin="normal"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment color={"primary"} position="start">
                                        <FontAwesomeIcon fixedWidth icon={['far', 'phone-office']}/>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Field
                            name="email"
                            label={intl.formatMessage({id: 'contact_labelEmail'})}
                            type="email"
                            component={TextField}

                            autoComplete={"email"}
                            fullWidth={true}
                            margin="normal"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment color={"primary"} position="start">
                                        <FontAwesomeIcon fixedWidth icon={['far', 'envelope']}/>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Field
                            name="message"
                            label={intl.formatMessage({id: 'contact_labelMessage'})}
                            component={TextField}

                            fullWidth={true}
                            multiline={true}
                            rows={6}
                            margin="normal"
                        />
                        <Button variant={"contained"} type={"submit"} disabled={isSubmitting}>
                            {isSubmitting &&
                            <React.Fragment>
                                <FontAwesomeIcon fixedWidth={true} icon={['far', 'spinner']} spin/> <FormattedMessage id="submitting"/>
                            </React.Fragment>
                            }
                            {!isSubmitting &&
                            <React.Fragment>
                                <FontAwesomeIcon fixedWidth={true} icon={['far', 'paper-plane']}/> <FormattedMessage id="submitButton"/>
                            </React.Fragment>
                            }
                        </Button>
                    </Form>

                )}
            </Formik>
            <Dialog open={successDialogOpen} onClose={() => setSuccessDialogOpen(false)}>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <FormattedMessage id="contact_contactFormSuccess"/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant={"contained"} onClick={() => setSuccessDialogOpen(false)} autoFocus>
                        <FormattedMessage id="close"/>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default ContactForm;
